export default __webpack_public_path__ + "static/media/saas-icon.17193786.svg";